import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        const header = document.querySelector(".header") as HTMLElement | null;
        const headerOffset = (header?.offsetHeight ?? 0) + 16;
        const top =
          target.getBoundingClientRect().top + window.scrollY - headerOffset;

        window.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
        return;
      }
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
